/**
 * Team API endpoints
 */
import axiosClient from './axiosClient';
import { Team } from '@/types';

export const teamAPI = {
  /**
   * Get all teams
   */
  getTeams: async (params?: {
    organization_id?: string;
    project_id?: string;
    skip?: number;
    limit?: number;
  }): Promise<Team[]> => {
    const response = await axiosClient.get<Team[]>('/teams', { params });
    return response.data;
  },

  /**
   * Get team by ID
   */
  getTeam: async (teamId: string): Promise<Team> => {
    const response = await axiosClient.get<Team>(`/teams/${teamId}`);
    return response.data;
  },

  /**
   * Create a new team (Admin only)
   */
  createTeam: async (teamData: {
    name: string;
    description?: string;
    organization_id: string;
    project_ids?: string[];
    user_ids?: string[];
  }): Promise<Team> => {
    const response = await axiosClient.post<Team>('/teams', teamData);
    return response.data;
  },

  /**
   * Update team
   */
  updateTeam: async (teamId: string, teamData: Partial<Team>): Promise<Team> => {
    const response = await axiosClient.put<Team>(`/teams/${teamId}`, teamData);
    return response.data;
  },

  /**
   * Delete team
   */
  deleteTeam: async (teamId: string): Promise<void> => {
    await axiosClient.delete(`/teams/${teamId}`);
  },

  /**
   * Remove project from team
   */
  removeProjectFromTeam: async (teamId: string, projectId: string): Promise<void> => {
    await axiosClient.delete(`/teams/${teamId}/projects/${projectId}`);
  },
};
